import React from "react";
import { Content, Section } from "sharedComponents";
import { MemberInfoContainer } from "../../member/containers/MemberInfoContainer";
import { BreadcrumbContainer } from "features/breadcrumb/containers/BreadcrumbContainer";
import { MemberPartiesContainer } from "features/member/containers/MemberPartiesContainers";
import { OrderDetailsContainer } from "../containers/OrderDetailsContainer";
import { Tabs } from "sharedComponents/dataDisplay/tabs";
import { PaymentTabContainer } from "../containers/PaymentTabContainer";
import { TransactionTabContainer } from "../containers/TransactionTabContainer";
import { OrdersContainer } from "../containers/OrdersContainer";
import { BillSplitTabContainer } from "../containers/BillSplitTabContainer";
import { PartyDiagnosticsSection } from "./PartyDiagnosticsSection";

export interface Props {
    displayMemberParties: boolean;
    singleUser: boolean;
    noTransactions: boolean;
    notGroupTabAdmin: boolean;
}

export const PartyPage = ({ displayMemberParties, noTransactions, singleUser, notGroupTabAdmin }: Props) => (
    <>
        <Content>
            <>
                <MemberInfoContainer />
                <Section>
                    {displayMemberParties && <MemberPartiesContainer />}
                </Section>
            </>
            <>
                <OrderDetailsContainer />
                <Section>
                    <Tabs
                        tabPanes={[
                            {
                                content: <PaymentTabContainer />,
                                label: "Payment summary",
                            },
                            {
                                content: <TransactionTabContainer />,
                                label: "Transactions",
                                disabled: noTransactions || notGroupTabAdmin,
                            },
                            {
                                content: <BillSplitTabContainer />,
                                label: "Bill split",
                                disabled: singleUser || notGroupTabAdmin || noTransactions,
                            },
                        ]}
                    />
                </Section>
                <OrdersContainer />
                <PartyDiagnosticsSection />
            </>
        </Content>
        <BreadcrumbContainer />
    </>
);
